/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAppDto } from '../../models/create-app-dto';
import { DynamicEdurepProperties } from '../../models/dynamic-edurep-properties';

export interface EdurepControllerGetDynamicAppProperties$Params {
      body: CreateAppDto
}

export function edurepControllerGetDynamicAppProperties(http: HttpClient, rootUrl: string, params: EdurepControllerGetDynamicAppProperties$Params, context?: HttpContext): Observable<StrictHttpResponse<DynamicEdurepProperties>> {
  const rb = new RequestBuilder(rootUrl, edurepControllerGetDynamicAppProperties.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DynamicEdurepProperties>;
    })
  );
}

edurepControllerGetDynamicAppProperties.PATH = '/edurep/dynamicAppProperties';
